<template>
    <div>
        <div v-show="!mostrarRateios">
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblCronogramaDesembolso"
                :itens="cronogramasDesembolsos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false">
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <btn-inserir-cronograma-desembolso
                            v-if="$temAcessoView('CONV-DES-01')"
                            :convenio="convenio"
                            @atualizarLista="atualizarLista()">
                        </btn-inserir-cronograma-desembolso>
                    </b-button-group>
                </template>
                <template slot="nuValorDesembolso" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorDesembolso | currency }}
                    </p>
                </template>
                <template slot="dtMesAno" slot-scope="data">
                    <p class="text-left m-0">
                        {{ data.dtMesAno ? $moment(data.dtMesAno).format('MM/YYYY') : '' }}
                    </p>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-cronograma-desembolso
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-DES-02') && !data.comprometidoNoRm"
                        :convenio="convenio"
                        :cronogramaDesembolso="data"
                        @atualizarLista="atualizarLista()">
                    </btn-atualizar-cronograma-desembolso>
                    <btn-excluir-cronograma-desembolso
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-DES-02') && !data.comprometidoNoRm"
                        :convenio="convenio"
                        :cronogramaDesembolso="data"
                        @atualizarLista="atualizarLista()"
                    ></btn-excluir-cronograma-desembolso>
                    <btn-mostrar-rateios
                        v-if="data.temComprometimento"
                        @atualizarComprometimento="comprometimento = $event"
                        :cronogramaDesembolso="data"
                    ></btn-mostrar-rateios>
                </template>
                <template slot="idRm" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.idRm }}
                    </p>
                </template>
                <template slot="statusComprometimento" slot-scope="data">
                    <app-status
                        :status="data.statusComprometimento">
                    </app-status>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarRateios">
            <rateios
                :convenio="convenio"
                :comprometimento="comprometimento"
                @atualizarCronograma="atualizarLista()"
                @voltarCronogramaDesembolso="voltarCronogramaDesembolso()">
            </rateios>
        </div>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnInserirCronogramaDesembolso from '../cadastro/cronogramaDesembolso/BtnInserirCronogramaDesembolso.vue'
import BtnExcluirCronogramaDesembolso from '../cadastro/cronogramaDesembolso/BtnExcluirCronogramaDesembolso.vue'
import BtnAtualizarCronogramaDesembolso from '../cadastro/cronogramaDesembolso/BtnAtualizarCronogramaDesembolso'
import BtnMostrarRateios from '../cadastro/cronogramaDesembolso/BtnMostrarRateios'
import Rateios from '../cadastro/cronogramaDesembolso/rateios/Rateios'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnInserirCronogramaDesembolso,
        BtnAtualizarCronogramaDesembolso,
        BtnExcluirCronogramaDesembolso,
        BtnMostrarRateios,
        Rateios
    },

    data() {
        return {
            cronogramasDesembolsos: [],
            comprometimento: null,
            itensSelecionados: [],
            erros: [],
            mostrarTabela: false,
            campos: [
                {
                    key: 'vcDescricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuParcela',
                    label: 'Parcela',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtMesAno',
                    label: 'Mês\\Ano',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuValorDesembolso',
                    label: 'Valor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'statusComprometimento',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center',
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        atualizarLista(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.cronogramasDesembolsos = response.data.cronogramasDesembolsos
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarComprometimento(comprometimento) {
            if (
                JSON.stringify(this.comprometimento) !=
                JSON.stringify(comprometimento)
            ) {
                this.atualizarLista()
            }
            this.comprometimento = comprometimento
        },

        voltarCronogramaDesembolso(){
            this.comprometimento = null;
        },
    },

    computed: {
        mostrarRateios() {
            return this.comprometimento !== null
        }
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.cronogramasDesembolsos = this.convenio.cronogramasDesembolsos
            }
        },

        comprometimento(n,o){
            this.comprometimento = n;
        }
    },
}
</script>
